//
//
//
//
//
//
//

import configApi from '@/store/apis/config'
import { getStaticShareUrl } from '@/tools/ObjectHelper'
import configs from '@/tools/configs'

export default {
  name: 'line-share-btn',
  props: {
    showWord: {
      type: Boolean,
      default: true
    },
    title: {
      type: String
    },
    desc: {
      type: String,
      default: ''
    },
    image: {
      type: String,
      default: 'https://m.give543.com/static/ogimgsmall.jpg'
    },
    nickname: {
      type: String,
      default: ''
    },
    shareSuc: {
      type: Function
    },
    url: {
      type: String
    },
    isCover: {
      type: Boolean,
      default: false
    },
    type: {
      type: String
    },
    size: {
      type: Number,
      default: 66
    },
    objectId: {
      type: Number
    },
    query: {
      type: String,
      default: ''
    }
  },
  methods: {
    share () {
      this.$ga.trackEvent('line_share', 'share', this.url)

      if (this.type === 'sponsor' || this.type === 'url') {
        this.lineShare(this.url)
        return
      }

      if (this.type === 'activity') {
        window.open(`http://line.me/R/msg/text/?${this.title}%0D%0A${this.url}`, '_blank')
        this.shareSuc && this.shareSuc()
        return
      }

      const shareUrl = getStaticShareUrl(this.type, this.objectId, this.query)
      if (shareUrl) {
        this.lineShare(shareUrl)
        return
      }

      configApi.getShareUrl(
        {
          url: this.url,
          title: this.type === 'moment' ? '' : this.title,
          description: this.desc ? this.desc.replace(/(<([^>]+)>)/ig, '') : '',
          image: encodeURI(this.image)
        },
        data => {
          if (data && data.id) {
            let href = `${configs.frontEndUrl}share/${data.id}`
            this.lineShare(href)
          }
        }
      )
    },
    lineShare (url) {
      let infoText = ''
      if (this.type === 'gift') {
        infoText = `${this.nickname}在贈物網分享了一則超棒的禮物，快點開看看！`
      } else if (this.type === 'need') {
        infoText = `${this.nickname}在贈物網發起了『${this.title}』的需求，一起來幫幫他吧！`
      } else if (this.type === 'story') {
        infoText = `推薦您贈物網上的好文：『${this.title}』`
      } else if (this.type === 'moment') {
        infoText = '嘿，我在贈物網發現了一篇有趣的說說，快點開看！'
      } else {
        infoText = this.title
      }
      window.open(`https://social-plugins.line.me/lineit/share?url=${encodeURIComponent(url)}&text=${encodeURIComponent(infoText + url)}`, '_blank')
      this.shareSuc && this.shareSuc()
    }
  }
}
